import { FontIcon } from '@intigral/shared';
import { get } from '@intigral/utils/lib/browser-storage/localStorage';
import { STORE_NAME } from '@intigral/constant';
import {
    Program,
    ProgramBox,
    ProgramContent,
    ProgramFlex,
    ProgramItem,
    ProgramStack,
    ProgramText,
    ProgramTitle,
    useProgram,
    Channel,
} from 'planby';
import cStyles from './tvguide.module.sass';

export const ProgramCard = ({
    program,
    dayWidth,
    onProgramSelect,
    selectedProgram,
    ...rest
}: {
    dayWidth: number;
    onProgramSelect: (program: Program, channel?: Channel) => void;
    selectedProgram: Program | undefined;
} & ProgramItem) => {
    const { styles, formatTime, set12HoursTimeFormat, isLive, isMinWidth, isRTL } = useProgram({
        program,
        ...rest,
    });

    const { data } = program;
    const { image, title, since, till, locked } = data;

    // Check if content is purchased by comparing channel subscriptionGUID with user's PPV list
    const userInfo = get(STORE_NAME.USER);
    const userPpvList = userInfo?.ppvList || [];
    const subscriptionGUID = data?.channel?.subscriptions?.[0]?.subscriptionGUID;
    const isPurchased = subscriptionGUID && userPpvList.some((ppv: any) => ppv.guid === subscriptionGUID);

    let shouldShowLock = Boolean(locked);

    // Only apply this condition if the channel has a PPV subscriptionGUID
    if (subscriptionGUID && subscriptionGUID.includes('PPV')) {
        shouldShowLock = !isPurchased;
    }

    const sinceTime = formatTime(since, set12HoursTimeFormat()).toLowerCase();
    const tillTime = formatTime(till, set12HoursTimeFormat()).toLowerCase();

    return (
        <ProgramBox
            width={styles.width}
            style={{ ...styles.position, backgroundColor: selectedProgram?.id == data?.id ? 'white' : '' }}
        >
            <ProgramContent
                width={styles.width}
                isLive={isLive}
                className={cStyles.program}
                onClick={() => onProgramSelect(data, data.channel)}
            >
                <ProgramFlex>
                    {/* {isLive && isMinWidth && <ProgramImage src={image} alt="Preview" />} */}
                    {isLive && <span className={cStyles.live}>Live</span>}
                    {shouldShowLock && (
                        <span className={cStyles.lock}>
                            <FontIcon name="lock" />
                        </span>
                    )}
                    <ProgramStack isRTL={isRTL}>
                        <ProgramTitle className={cStyles.prgTitle}>{title}</ProgramTitle>
                        <ProgramText className={cStyles.prgTime}>
                            {sinceTime} - {tillTime}
                        </ProgramText>
                    </ProgramStack>
                </ProgramFlex>
            </ProgramContent>
        </ProgramBox>
    );
};
